module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-08.d5545bf4.JPG";